import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Positioning } from "../../foundations/positioning.es.js";
import { styledOptions } from "../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import MuiBottomNavigationAction from "../../../node_modules/@mui/material/BottomNavigationAction/BottomNavigationAction.es.js";
import MuiBottomNavigation from "../../../node_modules/@mui/material/BottomNavigation/BottomNavigation.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
const BOTTOM_NAVIGATION_HEIGHT = "5rem";
const MuiBottomNavigationActionElement = styled(MuiBottomNavigationAction, styledOptions)(({
  isSelected,
  theme
}) => ({
  ".MuiBottomNavigationAction-label": {
    color: isSelected ? theme.palette.primary.main : Displaying.initial
  }
}));
function BottomNavigation({
  items,
  value,
  children,
  ref,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(BottomNavigationContainer, { showLabels: true, ref, ...rest, children: [
    items.map(function toBottomNavigationItems(item, index) {
      const selected = value === index;
      return /* @__PURE__ */ jsx(MuiBottomNavigationActionElement, { isSelected: selected, label: item.label, icon: selected ? item.activeIcon : item.icon }, item.label);
    }),
    children
  ] });
}
const BottomNavigationContainer = styled(MuiBottomNavigation)(({
  theme
}) => ({
  position: Positioning.fixed,
  width: "100vw",
  borderTop: `1px solid ${theme.palette.border.main}`,
  height: BOTTOM_NAVIGATION_HEIGHT,
  left: theme.spacing(0),
  bottom: theme.spacing(0),
  zIndex: theme.zIndex.drawer + 1
}));
export {
  BOTTOM_NAVIGATION_HEIGHT,
  BottomNavigation
};
//# sourceMappingURL=bottom-navigation.es.js.map
